// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=ChatSessionUpdate|schemaHash=a916fa9585410e4341b73884ef80de7c7c90215d

import { setDefinedValue } from '@myre/common-primitives';

export function parseChatSessionUpdateFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'title', _data.title);
  setDefinedValue(result, 'status', _data.status);

  return result;
}

export function parseChatSessionUpdateToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'title', _data.title);
  setDefinedValue(result, 'status', _data.status);

  return result;
}
